// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LinkOutlinedSvg from "@ant-design/icons-svg/es/asn/LinkOutlined";
import AntdIcon from '../components/AntdIcon';

var LinkOutlined = function LinkOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: LinkOutlinedSvg
  }));
};

LinkOutlined.displayName = 'LinkOutlined';
export default React.forwardRef(LinkOutlined);